import CSS from "./static/css/AddressInfoMain.module.css";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import AddressInfoView from "../AddressInfoView/AddressInfoView";
import AddressInfo from "../AddressInfo/AddressInfo";
import OvalIconButton from "../../../../Component/Elements/Button/OvalIconButton/OvalIconButton";
import { ADDRESS_INFO_MAIN_VIEW_MODE } from "./static/ts/const";
import useHistoryBackContralOverlayState from "../../../../Component/Elements/Overlay/hooks/useHistoryBackContralOverlayState.hook";
import DeliveryAddressListOverlay from "../DeliveryAddressListOverlay/DeliveryAddressListOverlay";
import QuantityController from "../../../../Component/Elements/QuantityController/QuantityController";
import { ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import { addressListManagerClass } from "../../static/ts/common.tools";
import { Address } from "react-daum-postcode";
import Label from "../../../../Component/Elements/LabelAndContent/Label";

const addressListManager = new addressListManagerClass();

const AddressInfoMain = (
    {
        address_index,

        address_qty,

        view_mode,

        product_qty, 
        total_address_qty,

        addressList,
        setAddressList,
    }:{
        address_index: number;

        address_qty: number;

        view_mode: "view" | "edit"; //  처음 렌더링될 때 보여줄 상태
        
        product_qty: number;
        total_address_qty: number;

        addressList: ProductDetail_SelectInformationDate_Address_Interface[];
        setAddressList: Dispatch<SetStateAction<ProductDetail_SelectInformationDate_Address_Interface[]>>;
    }
) => {
    const {
        isOpen,
        openOverlay,
        closeOverlay,
    } = useHistoryBackContralOverlayState(false);

    const [rowAddressData, setRowAddressData] = useState<Address | null>(null);

    // 지도 api를 통해 직접 업데이트가 이루어진 경우
    useEffect(() => {
        if(rowAddressData){
            addressListManager.editAddress({
                index: address_index,
                address_list: addressList,
                addressListSetter: setAddressList,
                data: {
                    ...addressList[address_index],
                    zip_code: rowAddressData.zonecode,
                    addr: rowAddressData.roadAddress,
                    building_no: rowAddressData.buildingCode,
                },
            })
        }
    }, [rowAddressData])

    return(
        <div className={CSS.l_AddressInfoMain_main}>            
            {
                view_mode === ADDRESS_INFO_MAIN_VIEW_MODE.view
                &&  <AddressInfoView
                        recipient_name={addressList[address_index].recipient_name}  
                        recipient_phone={addressList[address_index].recipient_phone}
                        zip_code={addressList[address_index].zip_code}
                        addr={addressList[address_index].addr}
                        addr_detail={addressList[address_index].addr_detail}
                        address_qty={address_qty}
                    />
            }

            {
                view_mode === ADDRESS_INFO_MAIN_VIEW_MODE.edit
                &&  <>
                        <AddressInfo
                            headerNode={                                
                                <OvalIconButton 
                                    onClick={openOverlay}
                                    preset={"history"}
                                />
                            }
                            setRowAddressData={setRowAddressData}
                            address_index={address_index}
                            addressList={addressList}
                            setAddressList={setAddressList}
                        />

                        <div className={CSS.l_AddressInfoMain_QuantityController_container}>
                            <Label>
                                수량
                            </Label>

                            <div className={CSS.l_AddressInfoMain_QuantityController_cover}>
                                <QuantityController
                                    number={address_qty}
                                    min={1}
                                    max={product_qty}
                                    is_add_disabled={total_address_qty >= product_qty}
                                    addNumHander={addressListManager.addQty.bind(null, {
                                        index: address_index,
                                        address_list: addressList,
                                        addressListSetter: setAddressList,
                                    })}
                                    subNumHander={addressListManager.subQty.bind(null, {
                                        index: address_index,
                                        address_list: addressList,
                                        addressListSetter: setAddressList,
                                    })}
                                    removeHander={addressListManager.removeAddress.bind(null, {
                                        index: address_index,
                                        address_list: addressList,
                                        addressListSetter: setAddressList,
                                    })}
                                />
                            </div>
                        </div>
                    </>
            }

            <DeliveryAddressListOverlay
                isOpen={isOpen}
                address_index={address_index}
                overlayCloseHandler={closeOverlay}
                addressList={addressList}
                setAddressList={setAddressList}
            />
        </div>
    )
}

export default AddressInfoMain;